import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { CreateAnalysisType } from '../types/types'
import { useAuth } from './useAuth'
import { throwOnError } from '../utils/throwOnError'

export const useGetAnalysisTypesQuery = () => {
  const { authFetch } = useAuth()
  return useQuery({
    queryKey: ['analysis-types'],
    queryFn: async () => {
      const { data, error } = await authFetch().GET('/analysis-types')
      if (error) {
        throwOnError(error)
      }
      return data
    }
  })
}

export const useGetAnalysisTypeByIdQuery = (analysisTypeId: number) => {
  const { authFetch } = useAuth()
  return useQuery({
    queryKey: ['analysis-types', analysisTypeId],
    queryFn: async () => {
      const { data, error } = await authFetch().GET(
        '/analysis-types/{analysisTypeId}',
        {
          params: {
            path: {
              analysisTypeId
            }
          }
        }
      )
      if (error) {
        throwOnError(error)
      }
      return data
    }
  })
}

export const useCreateAnalysisTypeMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (analysisType: CreateAnalysisType) => {
      const { data, error } = await authFetch().POST('/analysis-types', {
        body: analysisType
      })
      if (error) {
        throwOnError(error)
      }
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['analysis-types']
      })
    }
  })
}

export const useDeleteAnalysisTypeMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (analysisTypeId: number) =>
      await authFetch().DELETE('/analysis-types/{analysisTypeId}', {
        params: {
          path: {
            analysisTypeId
          }
        }
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['analysis-types']
      })
    }
  })
}
